import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="HumanOnRent.AI" className="w-11 h-11 rounded-xl" />
              <div>
                <span className="font-bold text-xl text-white">HumanOnRent.AI</span>
                <p className="text-[10px] text-gray-400">India's First AI-Driven Platform</p>
              </div>
            </Link>
            <p className="text-gray-400 mb-6 max-w-sm">
              India's first AI-driven platform for professional human rental services. 
              1 Lac+ verified humans available across all Indian cities and pin codes.
            </p>
            
            {/* WhatsApp Support */}
            <div className="space-y-3">
              <a 
                href="https://wa.me/919810502313" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-green-400 hover:text-green-300 transition-colors font-medium"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="w-5 h-5" />
                <span>All Support on WhatsApp</span>
              </a>
              <p className="text-gray-500 text-xs">For email & phone, visit our <Link to="/contact" className="text-orange-400 hover:text-orange-300">Contact page</Link></p>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-orange-400 transition-colors">FAQ</Link></li>
              <li><Link to="/help" className="text-gray-400 hover:text-orange-400 transition-colors">Help Center</Link></li>
              <li><Link to="/cities" className="text-gray-400 hover:text-orange-400 transition-colors">Cities We Serve</Link></li>
            </ul>
          </div>
          
          {/* Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-gray-400 hover:text-orange-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-orange-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund" className="text-gray-400 hover:text-orange-400 transition-colors">Refund Policy</Link></li>
              <li><Link to="/conduct" className="text-gray-400 hover:text-orange-400 transition-colors">Code of Conduct</Link></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-orange-400 transition-colors">All Services</Link></li>
              <li><Link to="/auth?role=provider" className="text-gray-400 hover:text-orange-400 transition-colors">Become a Provider</Link></li>
              <li><Link to="/membership" className="text-gray-400 hover:text-orange-400 transition-colors">Membership Plans</Link></li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                &copy; {currentYear} HumanOnRent.AI. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                A unit of Set India Business Pvt Ltd
              </p>
            </div>
            <Link 
              to="/auth?admin=true" 
              className="text-gray-500 text-sm hover:text-gray-400 transition-colors"
              data-testid="admin-link"
            >
              Admin Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
